const PROFILE_TYPES = {
    GUEST: 'guest',
    VERIFIED: 'verified',
    TEMPORARY: 'temporary',
};

export default PROFILE_TYPES;
